import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { OrderType } from '@/types/domain';
import { createIdbStorage } from './persist';

type OrderState = {
  orderType: OrderType | null;
  draftOrderId: string | null;
  setOrderType: (type: OrderType) => void;
  setDraftOrderId: (id: string | null) => void;
  reset: () => void;
};

const initial = {
  orderType: null,
  draftOrderId: null,
} satisfies Pick<OrderState, 'orderType' | 'draftOrderId'>;

export const useOrderStore = create<OrderState>()(
  persist(
    (set) => ({
      ...initial,
      setOrderType: (orderType) => set({ orderType }),
      setDraftOrderId: (draftOrderId) => set({ draftOrderId }),
      reset: () => set({ ...initial }),
    }),
    {
      name: 'hanami-order',
      storage: createIdbStorage(),
      partialize: (s) =>
        ({
          orderType: s.orderType,
          draftOrderId: s.draftOrderId,
        }) as OrderState,
    },
  ),
);
